module.exports = __webpack_public_path__ + "static/img/yonghu.ccd8864.png";


//////////////////
// WEBPACK FOOTER
// ./src/knowledgeBase/yonghu.png
// module id = 634E
// module chunks = 1